export default {
        areas: undefined,
        areaOptions: [],
        importOptions: [],
        loading: false,
        error: null,
        errorShow: false
}